/* Template: Component - Menu
========================================================================== */
template.component.menu = function() {

  var $menuToggle = $('.navigation-toggle'),
      $mainMenu = $('#primary-menu-mobile'),
      $overlay = $('.overlay'),
      $svgClose = $('.navigation-toggle__menu'),
      $svgMenu = $('.navigation-toggle__close'),
      buttonText = '.navigation-toggle__text';

  $menuToggle.click(function() {
      $mainMenu.toggle();
      $svgClose.toggle();
      $svgMenu.toggle();

      if($mainMenu.is(":visible")) {
          $overlay.show();
          $menuToggle.find(buttonText).text('Close');
          $(this).attr('aria-expanded', 'true');
      } else {
          $overlay.hide();
          $menuToggle.find(buttonText).text('Menu');
          $(this).attr('aria-expanded', 'false');
      }
  });
};
